import React, { useEffect, useState } from 'react';
import { Col, Container, Pagination, Row } from 'react-bootstrap';

export const BPagination = ({
                                itemsPerPage = 10, totalItems = 0, paginate = (current) => current, currentPage = 1,
                            }) => {

    const [maxPage, setMaxPage] = useState(0);


    useEffect(() => {
        setMaxPage(Math.ceil(totalItems / itemsPerPage));
        console.log(totalItems, itemsPerPage);
    }, [totalItems, itemsPerPage]);

    const handlePrevPage = (pageNumber) => {
        paginate(pageNumber);
    };

    const handleNextPage = (pageNumber) => {
        paginate(pageNumber);
    };

    return (maxPage > 1 ? <Container><Row>
        <Col>
            <span className="align-middle float-right py-2"> Page {currentPage} of {maxPage}</span>
        </Col>
        <Col lg={6} xs>
            <Pagination className="float-right">
                <Pagination.Item disabled={currentPage <= 1} onClick={() => handlePrevPage(currentPage - 1)}><i
                    className={currentPage > 1 ? 'fas fa-chevron-left' : 'fas fa-chevron-left text-muted'} /></Pagination.Item>
                <Pagination.Item disabled={currentPage >= maxPage} onClick={() => handleNextPage(currentPage + 1)}><i
                    className="fas fa-chevron-right" /></Pagination.Item>
            </Pagination>
        </Col>
    </Row></Container> : <></>);
};
